import { useEffect, useState } from "react";
import { BookOpen } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { ASSETS } from "@/lib/assets";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AboutSpeaker() {
  const [content, setContent] = useState(null);

  useEffect(() => {
    fetch(`${API}/content`).then((r) => r.json()).then(setContent).catch(() => {});
  }, []);

  if (!content) return null;
  const books = content.books || [];

  return (
    <section className="px-6 sm:px-10 lg:px-16 py-24 lg:py-32" data-testid="about-speaker-section">
      <div className="mx-auto max-w-[900px] text-center">
        <Reveal>
          <p className="text-[var(--gold)] uppercase tracking-[0.4em] text-xs mb-6">About the Speaker</p>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="font-display text-4xl sm:text-5xl text-[var(--cream)]">Matthew Lewis</h2>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="font-serif-alt text-xl sm:text-2xl text-[var(--muted)] mt-8 leading-relaxed" data-testid="about-speaker-text">
            {content.about_speaker}
          </p>
        </Reveal>
        <Reveal delay={0.25}>
          <img
            src={ASSETS.guildLogo}
            alt="Guild of Beer Sommeliers — Accredited Member"
            data-testid="guild-logo"
            className="w-36 sm:w-44 mx-auto mt-10 select-none"
          />
        </Reveal>
        {books.length > 0 && (
          <Reveal delay={0.3}>
            <div className="mt-10 flex flex-col sm:flex-row flex-wrap items-center justify-center gap-4">
              {books.map((b, i) => (
                <a
                  key={i}
                  href={b.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`buy-book-link-${i}`}
                  className="inline-flex items-center gap-3 rounded-full border border-[var(--gold)] text-[var(--gold)] px-8 py-4 uppercase tracking-[0.2em] text-xs font-semibold hover:bg-[var(--gold)] hover:text-[var(--bg)] transition-colors duration-300"
                >
                  <BookOpen className="w-4 h-4" />
                  {b.title}
                </a>
              ))}
            </div>
          </Reveal>
        )}
      </div>
    </section>
  );
}
